// Shared archived / purged lockdown banner shell for the staff entity forms
// (review #8). The outer chrome — colour by purged-vs-archived and the
// `lockdown-banner` testid — was copied byte-for-byte in ExhibitionForm,
// ZoneForm and ExhibitForm; only the message wording differs, so each form
// supplies its own `purged` / `archived` nodes.

import type { FC, ReactNode } from "react";

export interface LockdownBannerProps {
  isPurged: boolean;
  purged: ReactNode;
  archived: ReactNode;
}

const LockdownBanner: FC<LockdownBannerProps> = ({
  isPurged,
  purged,
  archived,
}) => (
  <div
    className={`px-4 py-3 rounded border ${
      isPurged
        ? "bg-zinc-100 border-zinc-300 text-zinc-700"
        : "bg-amber-50 border-amber-300 text-amber-900"
    }`}
    data-testid="lockdown-banner"
  >
    {isPurged ? purged : archived}
  </div>
);

export default LockdownBanner;
